module.exports = __webpack_public_path__ + "static/media/logo-donts-3.8c70854f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-donts-3.png
// module id = 1306
// module chunks = 0